import { render, staticRenderFns } from "./MaterialCreateEdit.vue?vue&type=template&id=e8b74e94"
import script from "./MaterialCreateEdit.vue?vue&type=script&lang=js"
export * from "./MaterialCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./MaterialCreateEdit.vue?vue&type=style&index=0&id=e8b74e94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports